import Vue from 'vue'

const transformer = (data) => {
  return {
    id: data.id,
    provider: data.provider,
    camp: data.camp,
    price: data.price,
    date: data.add_date,
  }
}

export default (supplyId, campId) => Vue.$http.get(`purchase/supplies/prices/history/${supplyId}/?camp=${campId}`)
  .then((response) => {
    const data = response.data.history.map(supply => transformer(supply))
    return data
  })


// WEBPACK FOOTER //
// ./src/services/purchase/fetchSuppliesHistory.js